import { signIn } from 'next-auth/react';
import { normalizeAuthCallbackPath, normalizeAuthProduct } from './productAuth';

export async function beginProductGoogleSignIn(product, callbackPath) {
  const safeProduct=normalizeAuthProduct(product);
  const safePath=normalizeAuthCallbackPath(callbackPath);
  const response=await fetch('/api/auth/product-origin',{
    method:'POST',headers:{'content-type':'application/json'},credentials:'same-origin',
    body:JSON.stringify({product:safeProduct,callbackUrl:safePath}),
  });
  if(!response.ok)throw new Error('Could not prepare product sign-in.');
  return signIn('google',{callbackUrl:new URL(safePath,window.location.origin).toString()});
}
